import { render } from "./CommonFields.vue?vue&type=template&id=5a24e246"
import script from "./CommonFields.vue?vue&type=script&lang=js"
export * from "./CommonFields.vue?vue&type=script&lang=js"
script.render = render

export default script